import React from 'react'

const NoMatch = () => {
  return (
    <div>404 PAGE NOT FOUND</div>
  )
}

export default NoMatch
